/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for Audio Pause Icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const NavAudioPause = (props) => {
  const { color, ...otherProps } = props;
  return (
    <SvgIcon viewBox="0 0 18 18" {...otherProps}>
      <g fill="none" fillRule="evenodd">
        <path d="M-3-3h24v24H-3z" />
        <path
          fill={color}
          d="M12.5 0h4A1.5 1.5 0 0 1 18 1.5v15a1.5 1.5 0 0 1-1.5 1.5h-4a1.5
        1.5 0 0 1-1.5-1.5v-15A1.5 1.5 0 0 1 12.5 0zM1.5 0h4A1.5 1.5 0 0 1 7
        1.5v15A1.5 1.5 0 0 1 5.5 18h-4A1.5 1.5 0 0 1 0 16.5v-15A1.5 1.5 0 0 1
        1.5 0z"
        />
      </g>
    </SvgIcon>);
};

NavAudioPause.propTypes = {
  color: PropTypes.string
};

NavAudioPause.defaultProps = {
  color: '#047B9C'
};

export default NavAudioPause;



// WEBPACK FOOTER //
// ./src/js/icons/NavAudioPause.jsx